import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, switchMap } from 'rxjs/operators';
import {
  EUISAPConnections,
  GetAllDestinations,
  GetAllDestinationsSuccess,
  GetSAPConfiguration, GetSAPConfigurations, GetSAPConfigurationsSuccess,
  GetSAPConfigurationSuccess,
  UpdateSAPConfiguration, UpdateSAPConfigurationSuccess,

} from '../actions/sap-actions';
import { SapServices } from '../../../core/connect-sap-cp.service';
import { of, empty } from 'rxjs';
import { MessageService } from 'app/global-proxy/services/message.service';

//import {MessageService} from '../../services/message.service';

@Injectable()
export class SapEffects {

  GetAllDestinationsEffect = createEffect(() =>
    this.actions$.pipe(
      ofType<GetAllDestinations>(EUISAPConnections.GetAllDestinations),
      switchMap((action) => this.sapServices.getAllDestinations(action.payload, action.content)),
      switchMap((destinations: any) => {
        if (destinations) {
          return of(new GetAllDestinationsSuccess(destinations));
        }
        else {
          return of(new GetAllDestinationsSuccess([]));
        }
      })
    )
  );
  UpdateConfigurationEffect = createEffect(() =>
    this.actions$.pipe(
      ofType<UpdateSAPConfiguration>(EUISAPConnections.UpdateSAPCPConfiguration),
      switchMap((action) => this.sapServices.updateConfiguartion(action.payload, action.guid)),
      switchMap((response: any) => {
        if (typeof response === 'boolean')
          return of(new UpdateSAPConfigurationSuccess(true));
        else {
          //this.messageService.showError(response.errorReason);
          return empty();
        }
      })
    )
  );
  GetSAPConfiguration = createEffect(() =>
    this.actions$.pipe(
      ofType<GetSAPConfiguration>(EUISAPConnections.GetSAPConfiguration),
      switchMap((action) => this.sapServices.getSAPConfiguration(action.payload).pipe(
        catchError(err => {
          return 'ERROR'
        })
      )
        .switchMap((results) => {
          if (results === 'ERROR')
            return 'ERROR';
          return of(results);
        })
      ),
      switchMap((response: any) => {
        if (response.result)
          return of(new GetSAPConfigurationSuccess(response.result));
        else if (response.errorReason) {
          //this.messageService.showError(response.errorReason);
          return empty();
        }
      })
    )
  );
  GetSAPConfigurations = createEffect(() =>
    this.actions$.pipe(
      ofType<GetSAPConfigurations>(EUISAPConnections.GetSAPConfigurations),
      switchMap((action) => this.sapServices.getSAPConfigurations()),
      switchMap((response: any) => {
        if (Array.isArray(response))
          return of(new GetSAPConfigurationsSuccess(response));
        else {
          //this.messageService.showError(response.errorReason);
          return empty();
        }
      })
    )
  );

  constructor(private actions$: Actions, private sapServices: SapServices, private messageService: MessageService) {
  }
}
